export function randomColor(){
    let color = '#'+Math.floor(Math.random()*16777215).toString(16);
        if(color.length === 6){
            return color + "1"
        } else {
            return color
        }
}